import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  LOCALE_DIRECTION,
  LOCALE_STORAGE_KEY,
  SUPPORTED_LOCALES,
  type Locale,
} from './types'

export function useLocale() {
  const { locale } = useI18n()

  const current = computed<Locale>(() => locale.value as Locale)
  const direction = computed(() => LOCALE_DIRECTION[current.value])
  const isRtl = computed(() => direction.value === 'rtl')

  function setLocale(next: Locale) {
    if (!SUPPORTED_LOCALES.includes(next)) return
    locale.value = next
    try {
      localStorage.setItem(LOCALE_STORAGE_KEY, next)
    } catch {
      /* ignore */
    }
    applyDocumentLocale(next)
  }

  function applyDocumentLocale(value: Locale) {
    const html = document.documentElement
    html.lang = value
    html.dir = LOCALE_DIRECTION[value]
  }

  return {
    locale: current,
    direction,
    isRtl,
    setLocale,
    applyDocumentLocale,
    supported: SUPPORTED_LOCALES,
  }
}
